import React, { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { Calendar } from '../components/ui/calendar';

export const DateField = ({ value, onChange, label, testId }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} aria-label={label}
          className="flex items-center gap-2 bg-gray-900 border border-gray-800 hover:border-gray-600 rounded-lg px-3 py-2 text-white text-sm transition-colors">
          <CalendarDays className="w-4 h-4 text-gray-400" />
          <span className="text-gray-500">{label}</span> {date ? format(date, 'dd/MM/yyyy', { locale: es }) : '—'}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-gray-950 border-gray-800 text-white" align="end">
        <Calendar mode="single" locale={es} selected={date} defaultMonth={date}
          onSelect={(d) => { if (d) { onChange(format(d, 'yyyy-MM-dd')); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
};

export default DateField;
